import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaCalendarAlt, FaUser, FaTag } from 'react-icons/fa';

const News = () => {
  const newsData = [{
      id: 12,
      title: "Women's Wellness Week at Columbiaa Hospital",
      date: "2026-08-01",
      author: "Admin",
      category: "Health Camp",
      image: "assets/images/banner/womenswellnessch1.jpg",
      summary: "Join us in celebrating Women's Wellness Week (August 1-7) with expert consultation and preventive health screening designed for every stage of a woman's life. Special consultation for just ₹299 includes FREE Breast Screening.",
      content: "Because Every Woman Deserves the Best Care! Join us in celebrating Women's Wellness Week (August 1-7) with expert consultation and preventive health screening designed for every stage of a woman's life. Highlights include Women's Health Check-ups, Obstetric Care & Pregnancy Support, Gynaecological Wellness Consultation, and Hormonal Health Management. Special Consultation is available for just ₹299 (Includes FREE Breast Screening). The event runs from August 1-7, 11:00 AM to 1:00 PM. Prior Appointment Required. Appointments: +91 85489 79899.",
      link: "/"
    },
    {
      id: 1,
      title: "Mega Health Checkup Camp at Columbiaa Hospital",
      date: "2026-07-11",
      author: "Admin",
      category: "Health Camp",
      image: "assets/images/about/camp1.jpg",
      summary: "Columbiaa Hospital conducted a mega health checkup camp featuring various departments, with a large number of patients visiting for comprehensive screenings and consultations.",
      content: "Columbiaa Hospital conducted a mega health checkup camp featuring various departments, with a large number of patients visiting for comprehensive screenings and consultations. The camp covered multiple specialties including cardiology, orthopedics, neurology, general medicine, and ophthalmology, ensuring holistic healthcare access under one roof. Patients benefited from free health assessments, diagnostic tests, and expert doctor consultations. The event saw an overwhelming response from the community, reflecting the trust and confidence people have in Columbiaa Hospital. Our medical team worked dedicatedly throughout the day to ensure each visitor received personalized attention and guidance. Such camps are part of our mission to promote preventive healthcare and make quality medical services accessible to all.",
      link: "/"
    },

    {
      id: 2,
      title: "Mega Health Checkup Camp at Columbiaa Hospital",
      date: "2026-06-13",
      author: "Admin",
      category: "Health Camp",
      image: "assets/images/about/camp2.jpg",
      summary: "A mega health checkup camp was organized at Columbiaa Hospital with participation from various departments, catering to a large number of patients for health screenings and consultations.",
      content: "A mega health checkup camp was organized at Columbiaa Hospital with participation from various departments, catering to a large number of patients for health screenings and consultations. The camp brought together specialists from cardiology, endocrinology, orthopedics, pediatrics, and general surgery to provide comprehensive health evaluations. A large number of patients visited the hospital to avail free checkups, laboratory tests, and follow-up advice. The initiative aimed at early detection of health issues and spreading awareness about preventive care. Columbiaa Hospital remains committed to organizing such community-focused health camps that bridge the gap between quality healthcare and the general public.",
      link: "/"
    },

    {
      id: 3,
      title: "Mega Health Checkup Camp at Columbiaa Hospital",
      date: "2026-05-09",
      author: "Admin",
      category: "Health Camp",
      image: "assets/images/about/camp3.jpg",
      summary: "Columbiaa Hospital hosted a mega health checkup camp with active involvement from various departments, drawing a large number of patients for medical screenings and consultations.",
      content: "Columbiaa Hospital hosted a mega health checkup camp with active involvement from various departments, drawing a large number of patients for medical screenings and consultations. The event featured dedicated stalls for cardiology, neurology, orthopedics, gynecology, and general medicine, allowing visitors to undergo thorough health assessments. A large number of patients visited the camp, taking advantage of free consultations, diagnostic services, and health awareness sessions. The camp highlighted the hospital's multidisciplinary strength and its dedication to community well-being. Columbiaa Hospital looks forward to conducting more such initiatives to support preventive health and early diagnosis.",
      link: "/"
    },
    {
      id: 11,
      title: "Columbiaa Hospital Launches 24/7 Dialysis Service",
      date: "2025-08-05",
      author: "Admin",
      category: "Hospital News",
      image: "assets/images/service/dialysis.jpg",
      summary: "Columbiaa Hospital, Kasturi Nagar proudly announces the launch of our advanced 24/7 Dialysis Centre, providing round-the-clock kidney care services for patients in Bangalore.",
      content: "Columbiaa Hospital, Kasturi Nagar proudly announces the launch of our advanced 24/7 Dialysis Centre, providing round-the-clock kidney care services for patients in Bangalore. This expansion reflects our commitment to delivering comprehensive healthcare solutions to the community. Our state-of-the-art dialysis unit is equipped with the latest technology and staffed by experienced nephrologists and specialized nursing personnel. The 24/7 service ensures that patients requiring dialysis can receive treatment at any time, addressing the critical need for flexible healthcare services in our community. We are dedicated to providing accessible, high-quality renal care that improves patient outcomes and quality of life.",
      link: "/dialysis"
    },

    {
      id: 10,
      title: "Free Mega Health Checkup Camp at KGF",
      date: "2025-07-15",
      author: "Admin",
      category: "Health Camp",
     image: "assets/images/about/mission.jpg",
      summary: "Columbiaa Hospital successfully organized a Free Mega Health Checkup Camp at Kolar Gold Fields (KGF), providing essential health screenings to over 500 community members.",
      content: "Columbiaa Hospital successfully organized a Free Mega Health Checkup Camp at Kolar Gold Fields (KGF), providing essential health screenings to over 500 community members. The camp was led by our team of specialist doctors including cardiologists, physicians, and surgeons who conducted comprehensive health examinations. Services offered included blood pressure monitoring, blood sugar testing, ECG, and specialist consultations. This initiative is part of our ongoing Corporate Social Responsibility (CSR) program aimed at making healthcare accessible to underserved communities. The overwhelming response from the KGF community has encouraged us to continue organizing such beneficial health camps across different locations in and around Bangalore.",
      link: "/"
    },

    {
      id: 9,
      title: "Dr. H. V. Satish Babu Recognized Among Top 10 Neurosurgeons in India",
      date: "2025-06-20",
      author: "Admin",
      category: "Awards & Recognition",
      image: "assets/images/about/hvsb.jpeg",
      summary: "We are proud to announce that Dr. H. V. Satish Babu, Medical Director and Senior Consultant Neurosurgeon at Columbiaa Hospital, has been recognized among the Top 10 Neurosurgeons in India.",
      content: "We are proud to announce that Dr. H. V. Satish Babu, Medical Director and Senior Consultant Neurosurgeon at Columbiaa Hospital, has been recognized among the Top 10 Neurosurgeons in India. This prestigious recognition highlights his exceptional contributions to the field of neurosurgery and his unwavering commitment to patient care. With over two decades of experience, Dr. Satish Babu has performed numerous complex brain and spine surgeries with outstanding results. His expertise in treating conditions such as brain tumors, spinal disorders, and cerebrovascular diseases has earned him recognition from peers and patients alike. This achievement is a testament to Columbiaa Hospital's dedication to providing world-class healthcare services led by highly skilled medical professionals.",
      link: "/"
    },

    {
      id: 4,
      title: "Neuro Outreach Clinic Brings Expert Care to West Bengal",
      date: "2025-05-10",
      author: "Admin",
      category: "Outreach Program",
      image: "assets/images/about/bengalcamp.png",
      summary: "Columbiaa Hospital's monthly Neuro Outreach Clinic continues to provide specialized neurological care to patients in West Bengal, making expert treatment accessible to remote areas.",
      content: "Columbiaa Hospital's monthly Neuro Outreach Clinic continues to provide specialized neurological care to patients in West Bengal, making expert treatment accessible to remote areas. Led by Dr. H. V. Satish Babu, our team conducts regular clinics at Medicare Hospital, Khotulpur, where patients can receive expert consultations without traveling to Bangalore. The outreach program has successfully screened and treated hundreds of patients suffering from various neurological conditions including brain tumors, spinal disorders, and stroke-related complications. By bringing world-class neurosurgical expertise to West Bengal, we are bridging the healthcare gap and ensuring that patients receive timely medical attention. This initiative reflects our vision of making specialized healthcare accessible to all, regardless of their geographical location.",
      link: "/"
    },

    {
      id: 8,
      title: "World Purple Day: Columbiaa Hospital Raises Epilepsy Awareness",
      date: "2025-03-26",
      author: "Admin",
      category: "Awareness Campaign",
      image: "assets/images/gallery/purpleday/1.png",
      summary: "Columbiaa Hospital joined the global observance of World Purple Day, organizing activities to raise awareness about epilepsy and support individuals and families affected by the condition.",
      content: "Columbiaa Hospital joined the global observance of World Purple Day, organizing activities to raise awareness about epilepsy and support individuals and families affected by the condition. Our neurology team conducted an awareness session educating the public about epilepsy, its symptoms, and the importance of early intervention. Interactive demonstrations on seizure first aid were provided to help community members learn how to assist someone experiencing a seizure safely. Information materials about epilepsy management and available treatment options were distributed. The event also featured testimonials from patients who have successfully managed their condition with proper medical care. Through these efforts, Columbiaa Hospital continues to break the stigma surrounding epilepsy and promote understanding and support for those living with neurological conditions.",
      link: "/"
    },

    {
      id: 5,
      title: "Cancer Awareness Walkathon Promotes Early Detection",
      date: "2025-02-04",
      author: "Admin",
      category: "Awareness Campaign",
      image: "assets/images/background/service-bg.jpg",
      summary: "Columbiaa Hospital organized a Cancer Awareness Walkathon on World Cancer Day, drawing participation from over 1000 community members to promote cancer prevention and early detection.",
      content: "Columbiaa Hospital organized a Cancer Awareness Walkathon on World Cancer Day, drawing participation from over 1000 community members to promote cancer prevention and early detection. The walkathon started from our hospital in Kasturi Nagar and covered a distance of 5 kilometers through the neighborhood. Participants were educated about the importance of regular health checkups, recognizing early warning signs of cancer, and maintaining a healthy lifestyle to reduce cancer risk. Our oncology specialists were present to answer questions and provide information about the latest advances in cancer treatment. The event concluded with a free cancer screening camp where participants could avail themselves of preliminary health assessments. We remain committed to raising awareness about cancer and supporting our community in the fight against this disease.",
      link: "/"
    },

    {
      id: 6,
      title: "Continuing Nursing Education Programme Enhances Healthcare Quality",
      date: "2025-01-15",
      author: "Admin",
      category: "Education",
      image: "assets/images/about/cne.png",
      summary: "Columbiaa Hospital conducted a Comprehensive Continuing Nursing Education (CNE) Programme to update nursing staff on the latest healthcare practices and protocols.",
      content: "Columbiaa Hospital conducted a Comprehensive Continuing Nursing Education (CNE) Programme to update nursing staff on the latest healthcare practices and protocols. The programme featured sessions on advanced patient care techniques, infection control measures, emergency response procedures, and the use of modern medical equipment. Our nursing team had the opportunity to learn from renowned healthcare professionals and experts in various medical fields. The CNE programme underscores our commitment to maintaining the highest standards of nursing care and ensuring that our staff remains updated with the latest developments in healthcare. By investing in continuous education, we empower our nursing team to deliver exceptional patient care and contribute to better health outcomes.",
      link: "/"
    },

    {
      id: 7,
      title: "Free Bone Mineral Density Camp Benefits Senior Citizens",
      date: "2024-12-20",
      author: "Admin",
      category: "Health Camp",
     image: "assets/images/about/bmd.jpeg",
      summary: "A Free Bone Mineral Density (BMD) Camp was organized at Columbiaa Hospital, providing essential osteoporosis screening for over 200 senior citizens in the community.",
      content: "A Free Bone Mineral Density (BMD) Camp was organized at Columbiaa Hospital, providing essential osteoporosis screening for over 200 senior citizens in the community. The camp was designed to address the growing concern of osteoporosis among elderly populations, offering quick and painless bone density tests. Our orthopedic specialists were available to interpret results and provide personalized recommendations for maintaining bone health. Participants also received valuable guidance on nutrition, exercise, and lifestyle modifications to prevent and manage osteoporosis. The overwhelming response to the camp highlights the community's need for accessible preventive healthcare services. Columbiaa Hospital remains dedicated to organizing such beneficial health camps that contribute to the well-being of our community members.",
      link: "/"
    },  ];

  return (
    <>
      <Helmet>
        <title>News & Updates | Columbiaa Hospital, Kasturi Nagar, Bangalore</title>
        <meta name="description" content="Stay updated with the latest news and announcements from Columbiaa Hospital, Kasturi Nagar, Bangalore. Read about hospital developments, health camps, awards, and community initiatives." />
        <meta name="keywords" content="news, updates, Columbiaa Hospital, Kasturi Nagar, Bangalore, hospital news, health camp, medical news, healthcare updates" />
      </Helmet>

     
       {/* Page Title */}
  
      <section
  className="page-title py-5"
  style={{
    backgroundImage: "url(assets/images/background/page-title-2.jpg)",
    overflowX: "hidden",
  }}
  aria-label="Contact Page Banner"
>
  <div
    className="pattern-layer"
    style={{
      backgroundImage: "url(assets/images/shape/pattern-35.png)",
    }}
  ></div>
  <div className="container">
    <div className="row justify-content-center">
      <div
        className="col-12 col-md-10 text-center"
        data-aos="fade-right"
      >
        <div className="title-box my-4 my-md-0">
          <h1 className="display-4">Columbiaa Health Bulletin</h1>
          <p className="lead">Columbiaa Hospital – Your Health Care Partner in Kasturi Nagar, Bangalore.</p>        </div>
      </div>
    </div>
  </div>
</section>

      <section className="news-section py-5" aria-label="News articles section">
        <div className="container">
          <div className="row">
            {newsData.map((news) => (
              <div key={news.id} className="col-md-6 col-lg-4 mb-4" role="article" aria-label={`News article: ${news.title}`}>
                <div className="card h-100 shadow-sm border-0" style={{ transition: "transform 0.3s" }}>
                  <img
                    src={news.image}
                    className="card-img-top"
                    alt={news.title}
                    style={{ height: "200px", objectFit: "cover" }}
                    loading="lazy"
                    aria-label={`Image for news: ${news.title}`}
                  />
                  <div className="card-body d-flex flex-column">
                    <div className="mb-2" style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                      <span className="mr-3" aria-label={`Date: ${news.date}`}>
                        <FaCalendarAlt className="mr-1" aria-hidden="true" /> {news.date}
                      </span>
                      {/* <span aria-label={`Author: ${news.author}`}>
                        <FaUser className="ml-3 mr-1" aria-hidden="true" /> {news.author}
                      </span> */}
                    </div>
                    <div className="mb-2">
                      <span
                        className="badge badge-primary"
                        aria-label={`Category: ${news.category}`}
                      >
                        <FaTag className="mr-1" aria-hidden="true" /> {news.category}
                      </span>
                    </div>
                    <h5 className="card-title font-weight-bold" aria-label={`News title: ${news.title}`}>
                      {news.title}
                    </h5>
                    <p className="card-text text-muted" aria-label={`News summary: ${news.summary}`}>
                      {news.summary}
                    </p>
                    <Link
                      to={news.link}
                      className="btn btn-outline-primary mt-auto"
                      aria-label={`Read more about ${news.title}`}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default News;


